import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOskDetailsVm } from '../osk-details-vm.model';
import { IOskDetailsUm } from '../osk-details-um.model';
import { IOskDeleteResultVm } from '../osk-delete-result-vm.model';
@Injectable({ providedIn: 'root' })
export class OskService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/Osk`;
  }
  get(oskGuid: string): Observable<IOskDetailsVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (oskGuid !== undefined && oskGuid !== null) {
      params = params.set('oskGuid', oskGuid.toString());
    }
    return this.http.get<IOskDetailsVm>(this.baseUrl, { headers, params });
  }
  put(oskDetailsUm: IOskDetailsUm): Observable<IOskDetailsVm> {
    const headers = this.createHeaders();
    return this.http.put<IOskDetailsVm>(this.baseUrl, oskDetailsUm, { headers });
  }
  delete(oskGuid: string): Observable<IOskDeleteResultVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (oskGuid !== undefined && oskGuid !== null) {
      params = params.set('oskGuid', oskGuid.toString());
    }
    return this.http.delete<IOskDeleteResultVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
